import { Page404 } from '../Page404/Page404';
import { NotActive } from '@lk-gtcom/ecomlab-components';
import { PromotionRules } from '../PromotionRules/PromotionRules';
import { JoinedPromotions } from '../JoinedPromotions/JoinedPromotions';
import { ListPromotionVer2 } from '../ListPromotionVer2/ListPromotionVer2';
import { ProductsInCampaign } from '../ProductsInCampaign/ProductsInCampaign';
import { useState, useEffect } from 'react';
import { AnalyticalCollectionsOzon } from '../AnalyticalCollectionsOzon/AnalyticalCollectionsOzon';
import { ListOfAdvertisingCampaigns } from '../ListOfAdvertisingCampaigns/ListOfAdvertisingCampaigns';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';
import './MarketingOzon.scss'


const MarketingOzon = () => {
    const pathMain = useParams()
    const navigate = useNavigate()
    const [isActive, setIsActive] = useState('Аналитические подборкиРекламные кампании')
    const [isActiveItems, setIsActiveItems] = useState('')
    const modalsPortalId = 'modals-portal'

    const [showTooltipParametr, setShowTooltipParametr] = useState(false)
    const [showTooltipLauncAdvertisingCampaign, setShowTooltipLauncAdvertisingCampaign] = useState(false)
    const [showTooltipLauncAdvertisingCampaignInfo, setShowTooltipLauncAdvertisingCampaignInfo] = useState(false)

    useEffect(() => {

        if (pathMain['*'].split('/')[0] == 'not-active') {
            navigate('analytical-collections/all_product')
            setIsActive('Рекламные кампанииАналитические подборки')
            setIsActiveItems('')
        }

        if (pathMain['*'].split('/')[0] == 'сreating-an-advertising-campaign') {
            navigate('сreating-an-advertising-campaign')
            setIsActive('')
            setIsActiveItems('')
        }
    }, [])

    return (
        <div id={modalsPortalId} className='settings__content'>
            <div className='flex'>
                    <Routes>
                        <Route path='analytical-collections/*' element={<AnalyticalCollectionsOzon
                            setShowTooltipParametr={(e) => setShowTooltipParametr(e)}
                            setShowTooltipLauncAdvertisingCampaignInfo={(e) => setShowTooltipLauncAdvertisingCampaignInfo(e)}
                        />} />

                        {/* Список рекламных кампаний */}
                        <Route path='list-of-advertising-campaigns/*' element={<ListOfAdvertisingCampaigns/>} />

                        {/* Товары в кампании */}
                        <Route path='products-in-campaign/*' element={<ProductsInCampaign/>} />

                        {/* Вступление в акцию */}
                        <Route path='joined-promotions/*' element={<JoinedPromotions/>} />

                        {/* Список акций */}
                        <Route path='list-promotion/*' element={<ListPromotionVer2
                            setShowTooltipLauncAdvertisingCampaign={(e) => setShowTooltipLauncAdvertisingCampaign(e)}
                        />} />

                        {/* Правила */}
                        <Route path='promotion-rules/*' element={<PromotionRules />} />
                        
                        <Route path='not-active' element={<NotActive />} />
                        <Route path='*' element={< Page404 />} />
                    </Routes>
            </div>
        </div>
    )
}

export { MarketingOzon }